import { createSelector } from 'reselect'

const featureRootSelector = ({ billing }) => billing

const upcomingInvoiceSelector = createSelector(
  featureRootSelector,
  ({ upcomingInvoice }) => upcomingInvoice
)

export const isUpcomingInvoiceLoadingSelector = createSelector(
  upcomingInvoiceSelector,
  ({ loading }) => loading
)

export const upcomingInvoiceDataSelector = createSelector(
  upcomingInvoiceSelector,
  ({ invoice }) => invoice
)

export const ignoreCurrentChargeSelector = createSelector(
  upcomingInvoiceDataSelector,
  (invoice) => (invoice && invoice.ignore_charge) || false
)

export const upcomingInvoiceErrorSelector = createSelector(
  upcomingInvoiceSelector,
  ({ error }) => error
)
